import {
    Component,
    Input,
    Output,
    EventEmitter
}                           from "@angular/core";
  
@Component({
    selector: "ctm-search-criteria",
    template: require('./search.html')
})
export class CtmSearchCriteria {
    constructor(
    ) { 
    }
  
    @Input("use-search-command")
    public useSearchCommand: boolean;
    @Input("use-clear-command")
    public useClearCommand: boolean;
    
    @Output("search-command")
    public searchCommand: EventEmitter<any> = new EventEmitter();
    @Output("clear-command")
    public clearCommand: EventEmitter<any> = new EventEmitter();
      
    private onSearch() {
        if (this.searchCommand != undefined) {
            this.searchCommand.emit();
        }
    }
    private onClear() {
        if (this.clearCommand != undefined) {
            this.clearCommand.emit();
        }
    }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/_common/components/search/search.ts